export const ZOOM_CLIENT_ID = window.__IS_PROD__ ? 'HNQtc9byRd6o6e2nUkdcLQ' : 'chxXegoWRKyaBk73ViJR5A';
export const HUBSPOT_CLIENT_ID = window.__IS_PROD__ ? '847bbcdf-f0d7-4f98-b174-10122ebe9755' : 'cb66dd08-2130-4467-a668-c08226f3243e';
